export default {"src":"/_next/static/media/facebook-social.dda6fd15.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};